export default __webpack_public_path__ + "static/media/guia-mobile-dark-1.f1550419.png";